import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

interface ApiKeysState extends FilterState {
    successDialog: {
        open: boolean;
        createValue?: string;
    };
}

type StateWithApiKeys = { apiKeys: ApiKeysState };

const initialState: ApiKeysState = {
    successDialog: {
        open: false
    },
    filters: {
        keywords: [],
    }
};

const apiKeysSlice = createSlice({
    name: 'apiKeys',
    initialState,

    reducers: (create) => ({
        ...filterReducers,
        openSuccessDialog: create.reducer((state, action: PayloadAction<string>) => {
            state.successDialog.open = true;
            state.successDialog.createValue = action.payload;
        }),

        closeSuccessDialog: create.reducer((state) => {
            state.successDialog.open = false;
            state.successDialog.createValue = undefined;
        })
    })
});

// eslint-disable-next-line no-restricted-syntax
export default apiKeysSlice.reducer;
export const { openSuccessDialog, closeSuccessDialog, addNewFilter, removeFilter, clearFilters } = apiKeysSlice.actions;
export const selectFilters = (state: StateWithApiKeys) => state.apiKeys.filters;
export const selectSuccessDialog = (state: StateWithApiKeys) => state.apiKeys.successDialog;
